export default __webpack_public_path__ + "static/media/white-logo.0723c005.svg";